import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertNaoAplica'
})
export class ConvertNaoAplicaPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (value) {
            return value;
        }
        return 'Não se aplica';
    }
}
